module.exports = [{
      plugin: require('../../gatsby-plugin-gtm/gatsby-browser.js'),
      options: {"plugins":[],"gtmId":"GTM-P9FVGMK"},
    },{
      plugin: require('../../../node_modules/gatsby-plugin-react-helmet-canonical-urls/gatsby-browser.js'),
      options: {"plugins":[],"siteUrl":"https://toggl.com"},
    },{
      plugin: require('../../../node_modules/gatsby-plugin-image/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../../toggl/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
